/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { ContactStatusType } from './ContactStatusType.js';
import {
    ContactStatusTypeFromJSON,
    ContactStatusTypeFromJSONTyped,
    ContactStatusTypeToJSON,
} from './ContactStatusType.js';

/**
 * 
 * @export
 * @interface ContactStatus
 */
export interface ContactStatus {
    /**
     * 
     * @type {ContactStatusType}
     * @memberof ContactStatus
     */
    status?: ContactStatusType;
    /**
     * 
     * @type {Date}
     * @memberof ContactStatus
     */
    dateCreated?: Date;
}

/**
 * Check if a given object implements the ContactStatus interface.
 */
export function instanceOfContactStatus(value: object): boolean {
    return true;
}

export function ContactStatusFromJSON(json: any): ContactStatus {
    return ContactStatusFromJSONTyped(json, false);
}

export function ContactStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContactStatus {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'] == null ? undefined : ContactStatusTypeFromJSON(json['status']),
        'dateCreated': json['dateCreated'] == null ? undefined : (new Date(json['dateCreated'])),
    };
}

export function ContactStatusToJSON(value?: ContactStatus | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'status': ContactStatusTypeToJSON(value['status']),
        'dateCreated': value['dateCreated'] == null ? undefined : ((value['dateCreated']).toISOString()),
    };
}

